// removed by extract-text-webpack-plugin
module.exports = {"CountdownWrapper":"Countdown__CountdownWrapper--3yG1w","animatedElement":"Countdown__animatedElement--3zs8z","CountDownMessage":"Countdown__CountDownMessage--1XOl9","messageAnimation":"Countdown__messageAnimation--bch2R","CountdownTimer":"Countdown__CountdownTimer--1m_Vn","timerAnimation":"Countdown__timerAnimation--3ibUP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Countdown/Countdown.scss
// module id = 481
// module chunks = 0